<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container >
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-item :label="$t('label.recurringIndicatorFileNumber')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input :disabled='isCodeDisabled' v-decorator="['stdCycDocCode',validatorRules.stdCycDocCode]" :placeholder="$t('label.pleaseEnterTheCycleIndexFileNumber')" ></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.circularIndicatorFileName')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <!-- <a-input v-decorator="['stdCycDocName',validatorRules.stdCycDocName]" :placeholder="$t('label.pleaseEnterTheNameOfTheCircularIndicatorFile')" ></a-input> -->
              <mtc-lang-popover :whetherLang="whetherLang('stdCycDocName')" :popLists="getMainTablePop('stdCycDocName')">
                <a-input
                  v-decorator="['stdCycDocName',validatorRules.stdCycDocName]"
                  :read-only="whetherLang('stdCycDocName')"
                  @click="isLangClick('stdCycDocName', true)"
                  :placeholder="$t('label.pleaseEnterTheNameOfTheCircularIndicatorFile')"
                ></a-input>
              </mtc-lang-popover>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.breedingCategory')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['feedVarietiesId',validatorRules.feedVarietiesId]" :trigger-change="true" dictCode="pzlx" :placeholder="$t('label.pleaseSelectTheBreedingCategory')" />
<!--              <a-input v-decorator="['feedVarietiesId']" placeholder="请输入饲养品类"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.feedingStage')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedStageId',validatorRules.feedStageId]" :placeholder="$t('label.pleaseEnterTheFeedingStage')"  style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.cooperationModel')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['coperModeCode',validatorRules.coperModeCode]" :trigger-change="true" dictCode="hzms" :placeholder="$t('label.pleaseSelectTheCooperationMode')" />
<!--              <a-input v-decorator="['coperModeCode']" placeholder="请输入合作模式"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.feedingCycle')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list"  v-decorator="['feedCycCode',validatorRules.feedCycCode]" :trigger-change="true" dictCode="efs_md_archives,name,code,valid_flag='Y' and arch_type='90'" :placeholder="$t('label.pleaseSelectRearingPeriod')" />
              <!--<a-input v-decorator="['feedCycCode']" placeholder="请输入饲养周期"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.survivalRate')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['survivalRate',validatorRules.survivalRate]" :placeholder="$t('label.pleaseInputTheSurvivalRate')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.averageWeightOfAdultChickens')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['averageWeight',validatorRules.averageWeight]" :placeholder="$t('label.pleaseEnterTheAverageWeightOfAdultChickens')" style="width: 92%"/> {{ $t('label.kiloBird') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.feedingAmount')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedWeight',validatorRules.feedWeight]" :placeholder="$t('label.pleaseEnterTheFeedingRate')" style="width: 92%"/> {{ $t('label.kiloBird') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.realMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['realFmRatio',validatorRules.realFmRatio]" :placeholder="$t('label.pleaseEnterTheRealMeatRatio')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.regularRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['normFmRatio',validatorRules.normFmRatio]" :placeholder="$t('label.pleaseEnterTheRegularMeatRatio')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.serviceCompanyGuaranteePoint')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['seviCpnyBep',validatorRules.seviCpnyBep]" :placeholder="$t('label.pleaseEnterTheServiceCompanyGuaranteePoint')" style="width: 92%"/> {{ $t('label.rmbKilo') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.seedlingPriceToMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['seedMpr',validatorRules.seedMpr]" :placeholder="$t('label.pleaseEnterTheSeedlingPriceToMeatRatio')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.feedToMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['feedMpr',validatorRules.feedMpr]" :placeholder="$t('label.pleaseEnterFeedPriceToMeatRatio')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.vaccinePriceToMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['vaccinesMpr',validatorRules.vaccinesMpr]" :placeholder="$t('label.pleaseEnterVaccinePriceToMeatRatio')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.healthCareMedicinePriceToMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['hemeMpr',validatorRules.hemeMpr]" :placeholder="$t('label.pleaseEnterHealthDrugPriceToMeatRatio')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.treatmentMedicinePriceToMeatRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['drugMpr',validatorRules.drugMpr]" :placeholder="$t('label.pleaseEnterThePriceOfTherapeuticDrugs')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :label="$t('label.priceToMeatRatioForPayingFarmers')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['payFarmerMpr',validatorRules.payFarmerMpr]" :placeholder="$t('label.pleaseEnterTheMeatRatioOfTheCostOfPayingFarmers')" style="width: 96%"/> %
            </a-form-item>
          </a-col>
         <!-- <a-col :span="12">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['validFlag',, {'initialValue': 'Y'}]" placeholder="请输入是否有效"></a-input>
            </a-form-item>
          </a-col>-->
          <a-col :span="12">
            <a-form-item :label="$t('label.validOrNot')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['validFlag',{'initialValue': 'Y'}]" :trigger-change="true" dictCode="sfyx"  :placeholder="$t('label.pleaseChooseWhetherItIsValidOrNot')"/>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">{{$t('button.submit')}}</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <mtc-lang-modal/>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import { mtcLangModalMixin } from '@/mixins/mtcLangModalMixin'


  export default {
    name: 'EfsStdStandardCycleForm',
    mixins: [mtcLangModalMixin],
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        mainTable: 'efs_std_standard_cycle',
        isCodeDisabled: false,
        // form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
            stdCycDocCode: {rules: [
                    {required: true, message: this.$t('label.pleaseEnterTheCycleIndexFileNumber')},
                    { validator: (rule, value, callback) => validateDuplicateValue('efs_std_standard_cycle', 'std_cyc_doc_code', value, this.model.id, callback)},
                ]},
            stdCycDocName: {rules: [{required: true, message: this.$t('label.pleaseEnterTheNameOfTheCircularIndicatorFile')}]},
            feedVarietiesId: {rules: [{required: true, message: this.$t('label.pleaseSelectTheBreedingCategory')}]},
            feedStageId: {rules: [{required: true, message: this.$t('label.pleaseEnterTheFeedingStage')}]},
            coperModeCode: {rules: [{required: true, message: this.$t('label.pleaseSelectTheCooperationMode')}]},
            feedCycCode: {rules: [{required: true, message: this.$t('label.pleaseEnterTheFeedingCycle')}]},
            survivalRate: {rules: [{required: true, message: this.$t('label.pleaseInputTheSurvivalRate')}]},
            averageWeight: {rules: [{required: true, message: this.$t('label.pleaseEnterTheAverageWeightOfAdultChickens')}]},
            feedWeight: {rules: [{required: true, message: this.$t('label.pleaseEnterTheFeedingRate')}]},
            realFmRatio: {rules: [{required: true, message: this.$t('label.pleaseEnterTheRealMeatRatio')}]},
            normFmRatio: {rules: [{required: true, message: this.$t('label.pleaseEnterTheRegularMeatRatio')}]},
            seviCpnyBep: {rules: [{required: true, message: this.$t('label.pleaseEnterTheServiceCompanyGuaranteePoint')}]},
            seedMpr: {rules: [{required: true, message: this.$t('label.pleaseEnterTheSeedlingPriceToMeatRatio')}]},
            feedMpr: {rules: [{required: true, message: this.$t('label.pleaseEnterFeedPriceToMeatRatio')}]},
            vaccinesMpr: {rules: [{required: true, message: this.$t('label.pleaseEnterVaccinePriceToMeatRatio')}]},
            hemeMpr: {rules: [{required: true, message: this.$t('label.pleaseEnterHealthDrugPriceToMeatRatio')}]},
            drugMpr: {rules: [{required: true, message: this.$t('label.pleaseEnterThePriceOfTherapeuticDrugs')}]},
            payFarmerMpr: {rules: [{required: true, message: this.$t('label.pleaseEnterTheMeatRatioOfTheCostOfPayingFarmers')}]},

        },
        url: {
          add: "/standardCycle/efsStdStandardCycle/add",
          edit: "/standardCycle/efsStdStandardCycle/edit",
          queryById: "/standardCycle/efsStdStandardCycle/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        if(this.model.id){
          this.isCodeDisabled=true
        }else{
          this.isCodeDisabled=false
        }
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'stdCycDocCode','stdCycDocName','feedVarietiesId','feedStageId','coperModeCode','feedCycCode','survivalRate','averageWeight','feed Weight','realFmRatio','normFmRatio','seviCpnyBep','seedMpr','feedMpr','vaccinesMpr','hemeMpr','drugMpr','payFarmerMpr','enblStatId','createBy','createTime','modifyBy','modifyTime','delFlag','validFlag','stdType','feedWeight'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'stdCycDocCode','stdCycDocName','feedVarietiesId','feedStageId','coperModeCode','feedCycCode','survivalRate','averageWeight','feed Weight','realFmRatio','normFmRatio','seviCpnyBep','seedMpr','feedMpr','vaccinesMpr','hemeMpr','drugMpr','payFarmerMpr','enblStatId','createBy','createTime','modifyBy','modifyTime','delFlag','validFlag','stdType','feedWeight'))
      },
    }
  }
</script>